import type { CharacterCountError } from './extensions/characterCountValidation'

export interface EditorContentMessageKeys {
  required: string
  tooShort: string
  tooLong: string
}

export interface EditorContentErrorBounds {
  min: number
  max: number
}

type TranslateFn = (key: string, params?: Record<string, unknown>) => string

export function mapEditorContentErrorMessage(
  error: CharacterCountError,
  t: TranslateFn,
  keys: EditorContentMessageKeys,
  bounds: EditorContentErrorBounds,
): string {
  if (!error) {
    return ''
  }

  if (error === 'required') {
    return t(keys.required)
  }

  if (error === 'too_short') {
    return t(keys.tooShort, { min: bounds.min })
  }

  if (error === 'too_long') {
    return t(keys.tooLong, { max: bounds.max })
  }

  return ''
}
